import type { Effort, Model, PermissionMode } from './settings';

/**
 * Bridges the /new → /chat/$id jump. The Composer on /new creates
 * a session and then navigates; the ChatPage that mounts on the
 * new URL reads the pending payload from here, once, and fires it
 * over the socket. A module-level Map is adequate — we're a SPA
 * and the jump is immediate.
 */
type Pending = {
  userId: number;
  text: string;
  model: Model;
  permission: PermissionMode;
  attachments: string[];
  effort: Effort;
};

const pending = new Map<string, Pending>();

export function setPendingSend(
  userId: number,
  sessionId: string,
  text: string,
  model: Model,
  permission: PermissionMode,
  attachments: string[],
  effort: Effort,
): void {
  pending.set(sessionId, { userId, text, model, permission, attachments, effort });
}

export function peekPendingSend(sessionId: string, userId: number): Pending | undefined {
  const value = pending.get(sessionId);
  return value?.userId === userId ? value : undefined;
}

export function takePendingSend(sessionId: string, userId: number): Pending | undefined {
  const p = pending.get(sessionId);
  if (p?.userId !== userId) return undefined;
  pending.delete(sessionId);
  return p;
}

export function clearPendingSends(): void {
  pending.clear();
}
